import { hue } from "./color.js";
export default function (a, b) {
  var i = hue(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-interpolate@1.3.3@d3-interpolate/src/hue.js
// module id = 465
// module chunks = 0